import styled from 'styled-components'

export const HEADER_CONTAINER_HEIGHT = 72
export const HEADER_CONTAINER_HEIGHT_MOBILE = 64
const HEADER_RESPONSIVE_BREAKPOINT_1 = '1550px'
const HEADER_RESPONSIVE_BREAKPOINT_2 = '1290px'
const HEADER_RESPONSIVE_BREAKPOINT_3 = '1180px'

export const StyledHeader = styled.header<{ $backgroundColor: string; $bannerHeight?: number | null }>`
  transition:
    transform 0.3s ease-in,
    background-color 0.3s linear;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: ${(props) => props.$backgroundColor};
  z-index: 900;

  &.scroll-down {
    transform: translateY(0);
    background-color: ${(props) => props.theme.v2.surface.white};
  }
  &.scroll-up {
    transform: translateY(0);
    background-color: ${(props) => props.theme.v2.surface.white};
  }
  &.active {
    transform: translateY(0);
  }
  &.featuredBanner:not(&.scroll-down, &.scroll-up) {
    transform: translateY(${(props) => props.$bannerHeight || 56}px);

    @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
      transform: translateY(${(props) => props.$bannerHeight || 40}px);
    }
  }
`

export const StyledHeaderContainer = styled.div`
  height: ${HEADER_CONTAINER_HEIGHT}px;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    align-items: center;
    display: flex;
    padding: 0 24px;

    height: ${HEADER_CONTAINER_HEIGHT_MOBILE}px;

    svg {
      height: auto;
      display: block;
    }
  }

  /* Start styling for mobile menu button - affects normal and AMP header */
  .mobile-menu {
    color: ${(props) => props.theme.v2.onSurface.text};
    cursor: pointer;
    display: none;
    font-family: ${(props) => props.theme.v2.font.lotaGrotesqueRegular};
    font-size: ${(props) => props.theme.v2.typography.body.xs.fontSize};
    line-height: ${(props) => props.theme.v2.typography.body.xs.lineHeight};
    padding: 24px 0;
    z-index: 990;
    border: none;
    background: none;

    span {
      margin-right: 6px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
      align-items: center;
      display: flex;
      flex: 1;
    }
  }

  /* Start styling for navigation links - affects normal and AMP header */
  .default-nav {
    column-gap: 44px;
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 2fr 3fr auto 4fr 2fr;
    height: 100%;

    > :nth-child(2) {
      justify-self: end;
    }

    @media screen and (max-width: ${HEADER_RESPONSIVE_BREAKPOINT_1}) {
      grid-template-columns: 1fr 4fr 1fr 5fr 1fr;
      column-gap: 16px;
    }

    @media screen and (max-width: ${HEADER_RESPONSIVE_BREAKPOINT_2}) {
      grid-template-columns: 1fr 4fr 1fr 5fr 1fr;
      column-gap: 16px;
    }

    ul {
      margin: 0;
      padding: 0;
      display: flex;
      list-style-type: none;

      li {
        a {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 24px 16px;
          display: block;
          color: ${(props) => props.theme.v2.secondary.action};
          font-size: ${(props) => props.theme.v2.typography.body.m.fontSize};
          line-height: ${(props) => props.theme.v2.typography.body.m.lineHeight};
          font-family: ${(props) => props.theme.v2.font.lotaGrotesqueLight};
          transition: color 0.3s ease-in;
          &:hover {
            color: ${(props) => props.theme.v2.interactive.bright};
          }

          @media screen and (max-width: ${HEADER_RESPONSIVE_BREAKPOINT_3}) {
            font-size: ${(props) => props.theme.v2.typography.body.s.fontSize};
            line-height: ${(props) => props.theme.v2.typography.body.s.lineHeight};
            padding: 24px 8px;
          }
        }
      }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
      align-items: center;
      background-color: ${(props) => props.theme.v2.surface.white};
      display: flex;
      flex-direction: column;
      height: 100vh;
      overflow: hidden;
      padding-top: 44px;
      position: fixed;
      right: 0;
      top: 0;
      transform: translate(0%, -140%);
      transition: all 0.3s ease-in;
      width: 100vw;
      z-index: 910;

      > :nth-child(2) {
        padding-top: 16px;
      }

      ul {
        flex-direction: column;
        text-align: center;
        li {
          a {
            font-size: 24px;
            padding: 20px 16px;
          }
        }
      }

      &.mobile-nav {
        transform: translate(0%, 0%);
      }
    }
  }
`

const StyledLogo = styled.div`
  display: block;
  padding: 24px 16px 20px;
  z-index: 990;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    display: none;

    &.minimal {
      display: block;
    }
  }
`

const StyledMobileButton = styled.div`
  font-family: ${(props) => props.theme.v2.font.lotaGrotesqueRegular};
  display: none;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    flex: 1;
    display: block;
    text-align: right;

    a.button {
      padding: 10px 24px;
    }
  }
`
